var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stickyelement",staticClass:"wl-sticky",style:(_vm.cssStyles)},[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }